module.exports = __webpack_public_path__ + "img/labour.53c32c26.png";